import { DefaultFilterConfig } from 'app/area/shared/default-filters/types';
import { ExcelMappingValue } from './types-store';
import { ExcelMappingParam } from './types';

export const languageValidationParameter = 'description';

export const maxDescriptionLength = 254;

export const userGroupCodetableId = 19;

export const createInitialExcelMapping: ExcelMappingValue[] =
  [
    ExcelMappingParam.period,
    ExcelMappingParam.favouriteCondition,
    ExcelMappingParam.favouriteConditionValue,
    ExcelMappingParam.searchParameters,
    ExcelMappingParam.generationTime,
    ExcelMappingParam.urlForWebApplication
  ].map(id => ({ id, cell: '', range: '' }));

export enum CompanyReportFormIds {
  sequenceId = 'sequence',
  disabledId = 'disabled',
  subsetId = 'subset',
  template = 'template',
  defaultTemplate = 'defaultTemplate',
  language = 'language',
  predefinedDate = 'predefinedDate',
  usePredefDate = 'usePredefDate',
  textId = 'textId',
  textSet = 'textSet',
  textDescription = 'textDescription',
  metadataType = 'metadataType',
  cell = 'cell',
  range = 'range',
  emailSetting = 'emailSetting'
}

export const defaultFilterCompanyReportConfig: DefaultFilterConfig = {
  showRequired: true
};

export const CompanyReportForm = 'CompanyReportForm';
